// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Expanded  Chevron Icon.
 * @param {IconProps} props - The IconProps for the Expanded Chevron component.
 * @returns {ReactElement} The ExpandedChevron component.
 */
export const ExpandedChevronIcon = (props: IconProps) => {
  const { color = '#C1C1CF', ...rest } = props;
  return (
    <Icon viewBox='0 0 50 11' color={color} {...rest} id='expanded-chevron-icon'>
      <path
        id='Vector'
        d='M22.4777 0.366139C23.8723 -0.122046 26.1372 -0.122046 27.5318 0.366139L48.9532 7.86467C50.3478 8.35286 49.3946 10.0118 48 10.5C46.6054 10.9882 45.2937 10.122 43.8991 9.63386L24.9992 3.01797L6.09924 9.62996C4.70461 10.1181 2.89453 10.9882 1.49991 10.5C0.10529 10.0118 -0.349497 8.34896 1.04512 7.86077L22.4665 0.362234L22.4777 0.366139Z'
        fill='currentColor'
      />
    </Icon>
  );
};
